import { createRouter, createWebHistory } from 'vue-router';
import LoginForm from '../components/LoginForm.vue';
import RegisterForm from '../components/RegisterForm.vue';
import UserManagement from '../components/UserManagement.vue';
import SchedulesCalendar from '../components/SchedulesCalendar.vue';
import AdminDashboard from '../components/AdminDashboard.vue';
import HomePage from '../components/HomePage.vue';
import TransactionsManagement from '../components/TransactionsManagement.vue';
import AccountComponent from '../components/AccountComponent.vue';
import GroupsManagement from '../components/GroupsManagement.vue';
import LessonsManagement from '../components/LessonsManagement.vue';
import BillingPlanManagement from '../components/BillingPlanManagement.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage, // Assuming you create a Home component
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginForm,
  },
  {
    path: '/register',
    name: 'Register',
    component: RegisterForm,
  },
  {
    path: '/admin',
    name: 'AdminDashboard',
    component: AdminDashboard,
    meta: { requiresAuth: true, roles: ['admin', 'teacher', 'senior_teacher'] },
    children: [
      {
        path: 'user-management',
        name: 'UserManagement',
        component: UserManagement,
        meta: { requiresAuth: true, roles: ['admin'] }
      },
      {
        path: 'schedules',
        name: 'Schedules',
        component: SchedulesCalendar,
        meta: { requiresAuth: true, roles: ['admin', 'teacher', 'senior_teacher'] },
        props: true
      },
      {
        path: 'transactions-management',
        name: 'TransactionsManagement',
        component: TransactionsManagement,
        meta: { requiresAuth: true, roles: ['admin'] }
      },
      {
        path: 'account',
        name: 'Account',
        component: AccountComponent,
        meta: { requiresAuth: true, roles: ['admin', 'teacher', 'senior_teacher'] }
      },
      {
        path: 'groups-management',
        name: 'GroupsManagement',
        component: GroupsManagement,
        meta: { requiresAuth: true, roles: ['admin'] }
      },
      {
        path: 'lessons-management',
        name: 'LessonsManagement',
        component: LessonsManagement,
        meta: { requiresAuth: true, roles: ['admin'] }
      },
      {
          path: '/admin/billing-plans',
          name: 'BillingPlanManagement',
          component: BillingPlanManagement,
          meta: { requiresAuth: true, roles: ['admin'] } // Restrict to admins only
        },
    ]
  },
  // Add other routes as needed
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// Add navigation guards or other middleware if required
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token');
  const role = localStorage.getItem('role');
  // Check if route requires authentication
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!token) {
      // Redirect to login if user is not authenticated
      next({ path: '/login' });
    } else {
      // Check if the route requires admin role
      if (to.matched.some(record => record.meta.admin)) {
        if (role !== 'admin') {
          // Redirect if user is not admin
          next({ path: '/login' }); // Other page or show an error
        } else {
          next(); // Proceed to the route
        }
      } else {
        next(); // Proceed to the route if no admin check is needed
      }
    }
  } else {
    next(); // Proceed to the route if no authentication is required
  }
});

export default router;